export const generateRandomQuery = () => {
  var digits = 4;
  var c = "0123456789";
  var cl = c.length;
  var r = "";
  for (var i = 0; i < digits; i++) {
    r += c[Math.floor(Math.random() * cl)];
  }
  return r;
}
